import Home from './pages/Home';
import Publications from './pages/Publications';
import Team from './pages/Team';
import AboutUs from './pages/AboutUs';
import TablePeriodic from './pages/TablePeriodic';
import AdminPanel from './pages/AdminPanel.jsx';
import Login from './pages/Login.jsx';
import Humanitarian from './components/elements/Humanitarian';
import GreenChemistry from './components/elements/GreenChemistry';
import PreventWaste from './components/elements/PreventWaste';
import AtomEconomy from './components/elements/AtomEconomy';
import LessHazardous from './components/elements/LessHazardous';
import MolecularDesign from './components/elements/MolecularDesign';
import Solvents from './components/elements/Solvents';
import Energy from './components/elements/Energy';
import Renewable from './components/elements/Renewable';
import Catalysis from './components/elements/Catalysis';
import Degradation from './components/elements/Degradation';
import Measurement from './components/elements/Measurement';
import Frameworks from './components/elements/Frameworks';
import EconomyMarket from './components/elements/EconomyMarket';
import Metrics from './components/elements/Metrics';
import Policies from './components/elements/Policies';
import Tools from './components/elements/Tools';
import EnablingSystem from './components/elements/EnablingSystem';
import NobleElements from './components/elements/NobleElements';

const routes = [
    { path: "/", element: <Home /> },
    { path: "/publications", element: <Publications /> },
    { path: "/TPQVS", element: <TablePeriodic /> },
    { path: "/team", element: <Team /> },
    { path: "/about-us", element: <AboutUs /> },
    {path: "/login", element: <Login/>  },
    {path: "/adminPanel", element: <AdminPanel/>},
    { path: "/humanitarian", element: <Humanitarian /> },
    { path: "/greenchemistry", element: <GreenChemistry /> },
    { path: "/preventwaste", element: <PreventWaste /> },
    { path: "/atomeconomy", element: <AtomEconomy /> },
    { path: "/lessHazardous", element: <LessHazardous /> },
    { path: "/moleculardesign", element: <MolecularDesign /> },
    { path: "/solvents", element: <Solvents /> },
    { path: "/energy", element: <Energy/> },
    { path: "/renewable", element: <Renewable /> },
    { path: "/catalysis", element: <Catalysis /> },
    { path: "/degradation", element: <Degradation /> },
    { path: "/measurement", element: <Measurement /> },
    { path: "/frameworks", element: <Frameworks /> },
    { path: "/economymarket", element: <EconomyMarket /> },
    { path: "/metrics", element: <Metrics /> },
    { path: "/policies", element: <Policies /> },
    { path: "/tools", element: <Tools /> },
    { path: "/enablingsystem", element: <EnablingSystem /> },
    { path: "/nobleelements", element: <NobleElements /> },
];

export default routes;
